export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    program: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    headerLogoSarclisaPatient: string;
    headerLogoSarclisaHCP: string;
    headerLogoJevtana:string;
    genzymeLogo: string;
    LogoJevtana: string;
    LogoSarclisa:string;
    LogoSarclisaHcp:string;
    LogoElitek: string;
    headerLogoElitek:string;
    footerLogo: string;
    footerDrugLogo: string;
    footerPharmaLogo: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    enrollmentTypeQuestion: string;
    enrollmentTypePatient: string;
    enrollmentTypeHCP: string;
    isFederalQuestionIdPatient: string;
    isFederalAnswerYesIdPatient: string;
    isFederalAnswerNoIdPatient: string;
    isCommerciallyInsuredQuestionIdPatient: string;
    isCommerciallyInsuredAnswerYesIdPatient: string;
    isCommerciallyInsuredAnswerNoIdPatient: string;
    isCommerciallyInsuredQuestionIdHcp: string;
    isCommerciallyInsuredAnswerYesIdHcp: string;
    isCommerciallyInsuredAnswerNoIdHcp: string;
    isUSResidentQuestionIdPatient: string;
    isUSResidentAnswerYesIdPatient: string;
    isUSResidentAnswerNoIdPatient: string;
    isAbove18YearsOfAgeQuestionIdPatient: string;
    isAbove18YearsOfAgeAnswerYesIdPatient: string;
    isAbove18YearsOfAgeAnswerNoIdPatient: string;
    hasBeenPrescribedQuestionIdPatientElitek: string;
    hasBeenPrescribedAnswerYesIdPatientElitek: string;
    hasBeenPrescribedAnswerNoIdPatientElitek: string;
    iConsentQuestionId: string;
    iConsentAnswerYesId: string;
    iConsentAnswerNoId: string;
    hasBeenPrescribedQuestionIdPatientJevtana: string;
    hasBeenPrescribedAnswerYesIdPatientJevtana: string;
    hasBeenPrescribedAnswerNoIdPatientJevtana: string;
    hasBeenPrescribedQuestionIdPatientSarclisa: string;
    hasBeenPrescribedAnswerYesIdPatientSarclisa: string;
    hasBeenPrescribedAnswerNoIdPatientSarclisa: string;
    hasBeenPrescribedQuestionIdHcpElitek: string;
    hasBeenPrescribedAnswerYesIdHcpElitek: string;
    hasBeenPrescribedAnswerNoIdHcpElitek: string;
    hasBeenPrescribedQuestionIdHcpJevtana: string;
    hasBeenPrescribedAnswerYesIdHcpJevtana: string;
    hasBeenPrescribedAnswerNoIdHcpJevtana: string;
    hasBeenPrescribedQuestionIdHcpSarclisa: string;
    hasBeenPrescribedAnswerYesIdHcpSarclisa: string;
    hasBeenPrescribedAnswerNoIdHcpSarclisa: string;
    isFederalQuestionIdHcpElitek: string;
    isFederalAnswerYesIdHcpElitek: string;
    isFederalAnswerNoIdHcpElitek: string;
    isFederalQuestionIdHcpJevtana: string;
    isFederalAnswerYesIdHcpJevtana: string;
    isFederalAnswerNoIdHcpJevtana: string;
    isFederalQuestionIdHcpSarclisa: string;
    isFederalAnswerYesIdHcpSarclisa: string;
    isFederalAnswerNoIdHcpSarclisa: string;
    isUSResidentQuestionIdHcp: string;
    isUSResidentAnswerYesIdHcp: string;
    isUSResidentAnswerNoIdHcp: string;
    isAbove18YearsOfAgeQuestionIdHcp: string;
    isAbove18YearsOfAgeAnswerYesIdHcp: string;
    isAbove18YearsOfAgeAnswerNoIdHcp: string;
    eligibility_1_question_elitek_patient: string;
    eligibility_1_question_jevtana_patient: string;
    eligibility_1_question_sarclisa_patient: string;
    eligibility_1_question_elitek_hcp: string;
    eligibility_1_question_jevtana_hcp: string;
    eligibility_1_question_sarclisa_hcp: string;
    eligibility_2_question_patient: string;
    eligibility_2_question_hcp: string;
    eligibility_3_question_patient: string;
    eligibility_3_question_elitek_hcp: string;
    eligibility_3_question_jevtana_hcp: string;
    eligibility_3_question_sarclisa_hcp: string;
    eligibility_4_question_patient: string;
    eligibility_4_question_hcp: string;
    eligibility_5_question_patient: string;
    eligibility_5_question_hcp: string;
    eligibility_6_question: string;
    medicationPathName: string;
    jevtanaPatient: string;
    jevtanaHCP: string;
    elitekPatient: string;
    elitekHCP: string;
    sarclisaPatient: string;
    sarclisaHCP: string;
    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
    COOKIEENVONE:string;
    DATADOMAIN:string;
}
